// src/services/leadershipEngine/scoreLevels.config.js

export function getNivelByRenda12m(renda12m = 0) {
  const r = Number(renda12m || 0);

  if (r <= 59000) {
    return {
      key: 'iniciante',
      label: 'Iniciante',
      faixa: 'até R$ 59 mil',
      // Vermelho -> Laranja -> Amarelo
      palette: ['#7a0f0f', '#c0392b', '#f1c40f'],
    };
  }

  if (r <= 120000) {
    return {
      key: 'junior',
      label: 'Júnior',
      faixa: 'R$ 60–120 mil',
      // Amarelo -> Amarelo-limão -> Verde claro
      palette: ['#f1c40f', '#d4e157', '#81c784'],
    };
  }

  if (r <= 300000) {
    return {
      key: 'pleno',
      label: 'Corretor Pleno',
      faixa: 'R$ 121–300 mil',
      // Verde -> Verde-água -> Azul celeste
      palette: ['#2ecc71', '#4dd0e1', '#81d4fa'],
    };
  }

  if (r <= 600000) {
    return {
      key: 'senior',
      label: 'Corretor Sênior',
      faixa: 'R$ 301–600 mil',
      // Azul celeste -> Azul -> Azul profundo
      palette: ['#4fc3f7', '#2196f3', '#0d47a1'],
    };
  }

  return {
    key: 'elite',
    label: 'Corretor Elite',
    faixa: 'acima de R$ 601 mil',
    // Azul safira / royal premium
    palette: ['#0b1c2d', '#0f2a44', '#123c5f'],
  };
}
